import { showError } from '../default/showError'

/**
 * hides OTP loader animation
 * @param {HTMLElement} otpEl - The otp element
 * @returns {void}
 */

export function resetOtpLoader(otpEl) {
  if (otpEl) {
    showError(otpEl, 'Invalid code. Please try again.')
    otpEl.shadowRoot
      ?.querySelector('.small-loader')
      ?.setAttribute('style', 'opacity: 0')
    otpEl.shadowRoot?.querySelector('form')?.reset()
    otpEl.setAttribute('value', '')
    otpEl.shadowRoot?.querySelector('input')?.focus()
  }
}
